module.exports = "/static/assets/cd77be4ebde61bded8556897c1f7e11f.png";